<template>
  <div class=""  v-bind:class="{
        classPopup: showPopup
      }"   v-if="showVideo">
    <section
      class="movie-detail-container d-flex flex-column details h-75"
      :style="{
        'background-image': 'url(' + currentVideo.thumbnail.large + ')',
      }"
    >
      <HomeNav />
      <div class="mt-auto flex-shrink-0">
        <div class="container-fluid">
          <div class="row justify-content-end">
            <div class="col-md-12 col-lg-6 col-xl-6">
              <h1  class="mt-5 text-white movie-heading">
                {{ currentVideo.name }}
              </h1>
              <div class="row text-white py-3"></div>
              <p class="text-white" style="font-size:1vw;">
                {{ currentVideo.description }}.
              </p>
              <p class="text-white">
                <!-- Starring:<span
                                    v-for="(Starring, index) in seasonsStarring"
                                    :key="index"
                                    >{{ Starring }}</span
                                > -->
              </p>
              <p>
                <a
                  @click="startVideo(currentVideo)"
                  v-if="!shouldShowResumeButton(currentVideo)"
                  class="btn btn-lg btn-outline-light ml-2"
                  >Start Watching</a
                >
                <a
                  :href="getresumeHref(currentVideo)"
                  class="btn btn-lg btn-outline-light ml-2"
                  v-if="shouldShowResumeButton(currentVideo)"
                  >Resume</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-auto">
        <div class="container">
          <ul class="nav custom-tabs" id="pills-tab" role="tablist">
            <li class="nav-item mr-5">
              <a
                class="nav-link active"
                data-toggle="pill"
                href="#episodes"
                role="tab"
                aria-selected="true"
                >EPISODES</a
              >
            </li>
            <li class="nav-item mr-5">
              <a
                class="nav-link"
                data-toggle="pill"
                href="#morelink"
                role="tab"
                aria-selected="true"
                >MORE LIKE THIS</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="pill"
                href="#movie-detail"
                role="tab"
                aria-selected="false"
                >DETAILS</a
              >
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="detail-block tab-content" id="pills-tabContent">
      <div class="container tab-pane fade show active" id="episodes">
        <div class="row mt-5">
          <div
            class="col-md-6 col-lg-4 "
            v-for="(card, index) in category_data"
            :key="index"
          >
            <div class="card episode">
              <div class="card-img-top">
                <img class="card-img-top" :src="card.coverart.large" alt="" />
                <div class="episode-number">
                  {{ index + 1 }}
                </div>
                <a @click="playvideo(card)" class="btn-play"
                  ><i class="fa fa-play"></i
                ></a>
              </div>
              <div class="card-body">
                <h5 class="card-title">
                  Episode {{ index + 1 }}
                  <span class="float-right">{{
                    currentSeasonVideosRunningTime(card)
                  }}</span>
                </h5>
                <p class="card-text">
                  {{ currentSeasonVideosDescription(card) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="container-fluid tab-pane fade" id="morelink">
                <div class="d-flex flex-wrap justify-content-center">
                    <div
                        class="col-desktop"
                        v-for="(card, index) in category_data"
                        :key="index"
                    >
                        <div class="series-block withhover">
                            <img class="img-fluid" :src="card.thumbnail.large" alt="" />
                            <div class="more-cnt text-center">
                                <h5 class="pt-3">{{ card.name}}</h5>
                                <p class="py-2">Duration {{ categoryDataRunningTime(card) }}</p>
                                <p>PG13</p>
                                <p class="py-3">{{ card.description }}</p>
                                <div class=" d-flex justify-content-between">
                                    <a class="">
                                        <img src="../assets/img/up.svg" alt="" />
                                    </a>
                                    <a class="">
                                        <img src="../assets/img/dwn.svg" alt="" />
                                    </a>
                                    <a class="" @click="toggleFavorited(card)">
                                        <img
                                            src="../assets/img/minis-icon.svg"
                                            v-if="my_favourite(card)"
                                            alt=""
                                        />
                                        <img src="../assets/img/plus.svg" v-else />
                                    </a>
                                </div>
                                <div class="py-3 d-flex justify-content-center">
                                    <a @click="gotoDetail(card)" class="d-inline-block">
                                        <img src="../assets/img/play.svg" class="play" alt="" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
      <div class="container tab-pane fade" id="movie-detail">
        <div class="row detail-link">
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Producer</h6>
              <p>
                {{ seasonsProducer }}
              </p>
            </div>
            <div class="mb-5">
              <h6 class="mb-3">
                Cast
              </h6>
              <p v-for="(cast, index) in seasonsCast" :key="index">
                {{ cast }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Writers</h6>
              <p v-for="(Writer, index) in seasonsWriter" :key="index">
                {{ Writer }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Genres</h6>
              <p v-for="(Genre, index) in seasonsGenres" :key="index">
                {{ Genre }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Maturity Rating</h6>
              <p>{{ seasonsMaturityRating }}</p>
            </div>
          </div>
        </div>
      </div>
      -->
    </section>
  </div>
</template>
<script>
import Category from "@/components/Category.vue";
import HomeNav from "@/components/HomeNav.vue";
export default {
  name: "DetailsList",
  components: {
    Category,
    HomeNav,
  },
  computed: {
    showplay() {
      if (this.$store.state.globalconfigs.enable_play == "false") {
        return false;
      } else {
        return true;
      }
    },

    	showPopup(){
			return this.$store.state.showPopup;
		},
  },
  filters: {
    trimdis: function(value) {
      return value.slice(0, 80) + "...";
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {
      category_data: {},
      showVideo: false,
      currentVideo: {},
      currentCat: "",
      options: null,
	  duidVal:null,
    resume: false
    };
  },
  methods: {
    getresumeHref(current) {
      this.resume = true;
        this.checkSubs(current);
    },
    my_favourite() {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == this.currentVideo.id) return true;
      }
      return false;
    },
    handleFav() {},

    playvideo(card) {
      this.checkSubs(card);
    },
    checkSubs(current) {
      this.$store.dispatch("getVideoById", current.id).then((res) => {
        this.video_name = res._embedded.collections[0].name;
        this.$store
          .dispatch("getVideoPlaybackURLV2", {
            videoId: current.id,
            deviceId: this.duidVal,
          })
          .then((res) => {
              if(this.resume == true){
                var dynamicRoute = "/viewvideo/" + current.id + "?resume=true";
                this.$router.push("" + dynamicRoute);
              }else
            var currentCat = current.id;
            var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          })
          .catch((err) => {
            if (err.response.data.error.status == "422") {
              // show upgrade screen popup
            }
            if (err.response.data.error.status == "403") {
              this.$store.commit("showPopup", true);
              this.$store.commit("showdefaultFooter", false)
              window.scrollTo(0, 0);
            }
			if (err.response.data.error.status == "404 ") {
        this.$store.commit("showPopup", true);
           // this.$store.commit("setNotification", "Please try again later ");
            window.scrollTo(0, 0);
          }
            this.$store.commit("setLoader", false);
          });
      });
    },

    startVideo(card) {
      var dynamicRoute = "/viewvideo/" + card._id;
      this.$router.push("" + dynamicRoute);
    },
    shouldShowResumeButton(video) {
      return this.$store.getters.isvideoResume(video._id);
    },

    seasonsProducer() {
      if (this.seasons.metaData.Producer) {
        return this.seasons.metaData.Producer;
      }
      return "";
    },
    seasonsCast() {
      if (this.seasons.metaData.Cast) {
        return this.seasons.metaData.Cast.split(",");
      }
      return [];
    },
    seasonsWriter() {
      if (this.seasons.metaData.Writers) {
        return this.seasons.metaData.Writers.split(",");
      }
      return [];
    },
    seasonsGenres() {
      if (this.seasons.metaData.Genres) {
        return this.seasons.metaData.Genres.split(",");
      }
      return [];
    },
    seasonsMaturityRating() {
      if (this.seasons.metaData["Maturity Rating"]) {
        return this.seasons.metaData["Maturity Rating"];
      }
      return "";
    },
    categoryDataName() {
      if (this.category_data.name) {
        return this.category_data.name;
      }
      return "";
    },
    categoryDataRunningTime(card) {
      if (card.metaData.running_time) {
        return card.metaData.running_time;
      }
      return "";
    },
    categoryDataDescription(card) {
      if (card.description) {
        return card.description;
      }
      return "";
    },
    currentSeasonVideosRunningTime(card) {
      if (card.metaData.running_time) {
        return card.metaData.running_time;
      }
      return "";
    },
    currentSeasonVideosDescription(card) {
      if (card.description) {
        return card.description;
      }
      return "";
    },
  },
  created() {
       this.$store.commit("showPopup", false);
    if (this.$store.state.user.logedin == false) {
      this.$store.commit("setLoader", false);
      this.$router.push("/login");
      return false;
    }
    this.currentCat = this.$route.params.catid;
    this.$store
      .dispatch("getCatalougeById", this.$route.params.catid)
      .then((res) => {
        this.currentVideo = res._embedded;
        this.showVideo = true;
      });
    this.$store
      .dispatch("getCatalougeById", this.$route.params.catid)
      .then((res) => {
        this.category_data = res._embedded.items;
        this.$store.commit("setLoader", false);
      });
  },
};
</script>
a,button{ cursor: pointer; }
<style scoped>
.details div {
  box-sizing: border-box;
  content: "";
}
.details {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 100px;
}
.current-video {
  width: 100%;
}
.cover-image {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-size: 100% 100%;
  border-bottom: 1px solid #000;
  opacity: 0.5;
}
.video-card {
  background-color: #000000;
  width: 80%;
  margin: 0 auto;
  color: #ffff;
  padding: 20px;
  margin-top: 16px;
  /*box-shadow: 0px 1px 10px 11px rgba(88, 86, 86, 0.5);*/
}
.video-card p {
  margin-bottom: 40px;
}
.recent-carousel {
  margin: 0 auto;
  width: 80%;
  position: relative;
  padding-top: 100px;
}
.gradient-div {
  position: absolute;
  width: 100%;
  bottom: 0px;
  border: 5px solid rgb(0, 0, 0);
  box-shadow: 0px -20px 50px 50px rgb(0, 0, 0);
}
.watchnow {
  padding: 10px;
  font-size: 1.2rem;
  border-radius: 3px;
  cursor: pointer;
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
  text-align: center;
}
.movie-detail-container {
  min-height: 85vh !important;
}
.mt-auto {
  position: relative;
  z-index: 1;
}

.series-block .more-cnt .btn-outline-light {
  color: #679f3d !important;
  border-color: #679f3d;
  background-color: #fff;
  padding: 2px 15px;
  box-shadow: 0px 0px 0px 3px white;
}

@media only screen and (max-width: 600px) {
  .cover-image {
    min-height: 50vh;
  }
  .video-card {
    background-color: #000000;
    width: 90%;
  }
}

.classPopup{
  position:fixed;
}
</style>
